import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'vault-auto-logout-confirm',
  templateUrl: './auto-logout-confirm.component.html',
  styleUrls: ['./auto-logout-confirm.component.scss'],
  standalone: false,
})
export class AutoLogoutConfirmComponent implements OnInit, OnDestroy {
  private timer$ = new BehaviorSubject<number>(30);
  private intervalId: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.intervalId = setInterval(() => {
      let time = this.timer$.value;
      time > 0 ? this.timer$.next(--time) : this.activeModal.close();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  public get timer(): Observable<number> {
    return this.timer$.asObservable();
  }
}
